import { StyleRules, DialogClassKey } from '@material-ui/core';

export const MuiDialog: Partial<StyleRules<DialogClassKey, {}>> = {
  paperWidthSm: {
    maxWidth: 696,
  },
};
